import React, { useCallback } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { ThinCheckbox } from 'components/common/Styles';

const VerificationTypeItem = ({ data }) => {
  const [t] = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/verificationTypes/${data.verificationTypeId}`);
  }, [historyContext, data]);

  return (
    <TableRow hover key={data.verificationTypeId}>
      <TableCell>{data.verificationName}</TableCell>
      <TableCell>{data.kindOfVerification}</TableCell>
      <TableCell align='center'>
        <ThinCheckbox disabled={true} checked={data.isActive} />
      </TableCell>
      <TableCell align='right'>
        <IconButton type='edit' size='small' variant='text' color='primary' tooltip={t('VerificationTypes.Edit')} onClick={handleEdit} />
      </TableCell>
    </TableRow>
  );
};

VerificationTypeItem.propTypes = {
  data: PropTypes.array.isRequired
};

export default VerificationTypeItem;
